import { findSessionsByIds, ICustomField } from "@gtmhub/customFields";
import { IGoalChildReorderResponse } from "@gtmhub/goals/models";
import { IPlanningSession } from "@gtmhub/sessions";
import { GhDndListComponentCtrl, GhDndListItemComponentCtrl } from "@gtmhub/shared/components";
import { IComponentOptions } from "angular";
export interface ICFItemComponentBindings {
  sessions: IPlanningSession[];
  shouldBeHighlightedCb(params: { item: ICustomField }): boolean;
  isCustomFieldViewed: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CFItemCtrl extends ICFItemComponentBindings {}

export class CFItemCtrl {
  public static $inject = ["CurrentUserService"];
  ghDndList: GhDndListComponentCtrl<IGoalChildReorderResponse, ICustomField>;
  ghDndListItem: GhDndListItemComponentCtrl<ICustomField>;
  private item: ICustomField;
  private cfTargetSessions: IPlanningSession[];

  $onInit(): void {
    this.item = this.ghDndListItem.item;
    this.cfTargetSessions = findSessionsByIds(this.sessions, this.item?.targetIds || []);
  }

  getCFTargetSessions = (): IPlanningSession[] => {
    return this.cfTargetSessions;
  };
}

export const CustomFieldsItemComponent: IComponentOptions = {
  require: { ghDndListItem: "^", ghDndList: "^" },
  bindings: {
    sessions: "<",
    shouldBeHighlightedCb: "&",
    isCustomFieldViewed: "<",
  },
  controller: CFItemCtrl,
  templateUrl: require("./cf-item.component.jade"),
};
